<mat-sidenav-container id="leftSideNavContainer" class="left-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav #leftSideNav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
        fixedTopGap="56" class="left-sidenav">
        <mat-nav-list>
            <ng-container *ngFor="let item of navData">
                <ng-container *ngTemplateOutlet="recursiveList; context: {$implicit: item, level: 0}"></ng-container>
            </ng-container>
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav #rightSidenav mode="side" position="end" class="right-sidenav-container">
        <app-assistant-container></app-assistant-container>
    </mat-sidenav>
    
    <mat-sidenav-content class="mat-drawer-content">
        <main>
            <div class="content-container">
                <router-outlet></router-outlet>
            </div>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #recursiveList let-item let-level="level">
    <div *ngIf="!item.children">
        <mat-list-item [routerLink]="item.route">
            <div style="flex-grow: 1; display: flex; align-items: center;" class="pointer-cursor">
                <mat-icon class="left-sidenav-icon">{{ item.iconImage }}</mat-icon>
                <span class="left-sidenav-title">{{ item.title }}</span>
            </div>
        </mat-list-item>
    </div>
    <div *ngIf="item.children">
        <mat-list-item (click)="toggleItem(item, level)">
            <div style="flex-grow: 1; display: flex; align-items: center;" class="pointer-cursor">
                <mat-icon class="left-sidenav-icon">{{ item.iconImage }}</mat-icon>
                <span class="left-sidenav-title">{{ item.title }}</span>
                <mat-icon class="left-sidenav-icon">{{ isExpanded(item, level) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
        </mat-list-item>
        <mat-nav-list *ngIf="isExpanded(item, level)">
            <ng-container *ngFor="let child of item.children">
                <ng-container *ngTemplateOutlet="recursiveList; context: {$implicit: child, level: level + 1}"></ng-container>
            </ng-container>
        </mat-nav-list>
    </div>
</ng-template>
